import { z } from 'zod';

export const orgRoleSchema = z.enum(['read', 'write', 'full']);
export type OrgRole = z.infer<typeof orgRoleSchema>;

export const inviteStatusSchema = z.enum(['Active', 'Pending']);
export type InviteStatus = z.infer<typeof inviteStatusSchema>;

export const orgMemberSchema = z.object({
  id: z.number(),
  partner: z.number(),
  user: z.object({
    email: z.string(),
    firstName: z.string(),
    lastName: z.string(),
  }),
  role: orgRoleSchema,
});
export type OrgMember = z.infer<typeof orgMemberSchema>;

export const organizationSchema = z.object({
  id: z.number(),
  name: z.string(),
  street: z.string(),
  city: z.string(),
  zipCode: z.string(),
  country: z.string(),
});
export type Organization = z.infer<typeof organizationSchema>;

export const createOrganizationRequestSchema = z.object({
  name: z.string().min(1),
  street: z.string(),
  city: z.string(),
  zipCode: z.string(),
  country: z.string(),
});
export type CreateOrganizationRequest = z.infer<typeof createOrganizationRequestSchema>;

export const updateOrganizationRequestSchema = createOrganizationRequestSchema.partial();
export type UpdateOrganizationRequest = z.infer<typeof updateOrganizationRequestSchema>;

export const inviteMemberRequestSchema = z.object({
  user: z.email(),
  role: orgRoleSchema,
});
export type InviteMemberRequest = z.infer<typeof inviteMemberRequestSchema>;
